<template>
  <div id="app">
    <header v-bind:class="{ active: this.$store.state.menuActive }">
		  <button class="toggle-nav" v-on:click="toggleNavigation()">
			    <span>></span>
		  </button>
		  <ul class="nav">
			    <li class="loud" v-on:click="toggleNavigation()">
            <router-link to="/" class="slide-i-o">
                        About
            </router-link>
          </li>
			    <li class="loud" v-on:click="toggleNavigation()">
            <router-link to="/about/timeline" class="slide-i-o">
                          Education / Experience
            </router-link>
          </li>
			    <li class="loud" v-on:click="toggleNavigation()">
            <router-link to="/project" class="slide-i-o">
                          Projects
            </router-link>
          </li>
			    <li class="loud" v-on:click="toggleNavigation()">
            <router-link to="/contact" class="slide-i-o">
                          Contact / CV
            </router-link>
          </li>
		  </ul>
	  </header>
    <main class="wrapper">
        <transition name="component-fade" mode="out-in">
          <router-view></router-view>
        </transition>
    </main>
  </div>
</template>

<script>

export default {
  name: 'app',
  methods: {
    toggleNavigation: function () {
      this.$store.state.menuActive = !this.$store.state.menuActive
    }
  }
}

</script>

<style src="./assets/site.scss" lang="scss"></style>
<style src="./assets/grid.css"></style>



// WEBPACK FOOTER //
// App.vue?50054a60